export default "__VITE_ASSET__ee931606__"